import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { allOptimizationObjectivesState } from '~/state/atoms/dose/optimizationObjectivesAtom';
import { roiColorsState } from '~/state/atoms/structureSet/roiAtoms';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';
import OptimizationObjectivesTable from './OptimizationObjectives';

const OptimizationObjectivesComponent = () => {
    const allRows = useRecoilValue(allOptimizationObjectivesState);
    const currentStructureSet = useRecoilValue(currentStructureSetState);

    const roiIds = useMemo(
        () => currentStructureSet?.roiArray.map((r) => r.roiId) ?? [],
        [currentStructureSet]
    );
    const roiColorMap = useRecoilValue(roiColorsState(roiIds));

    const structureColorMap = useMemo(() => {
        const map = new Map<string, string>();
        currentStructureSet?.roiArray.forEach((roi) => {
            const color = roiColorMap.get(roi.roiId);
            if (color) {
                map.set(roi.name, color);
            }
        });
        return map;
    }, [currentStructureSet, roiColorMap]);

    return (
        <OptimizationObjectivesTable
            rows={allRows}
            structureColorMap={structureColorMap}
        />
    );
};

export default OptimizationObjectivesComponent;
